<template lang="pug">
  .part.part-1
    .game__title.move-in(style="transition-delay: .05s")
      p 你的心跳聲#[br]將創作出什麼歌曲呢?
    .game__icon.move-in(style="transition-delay: .1s")
    .game__note.move-in(style="transition-delay: .15s")
      p 允許相機權限才能玩哦
    //- .game__agreement
    //-   label
    //-     input(type="checkbox" :checked="isAgreed" @change="$emit('change', $event.target.checked)")
    //-     span
    //-     p 我同意授權台新銀行使用遊戲過程中所偵測之
    //-     p 心跳速度數據，僅限用於本網站AI生成音樂用途
    //- a.game__button.game__button-start(href="#" @click.prevent="changePart(2)")
    //-   span 開始
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'GamePart1',
  props: {
    changePart: Function,
    // isAgreed: Boolean,
  },
  // model: {
  //   prop: 'checked',
  //   event: 'change',
  // },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState([])
  },
  methods: {
    ...mapActions([]),
  },
  mounted() {
    this.$trackPage('step1');
  },
  components: {
  }
}
</script>

<style lang="scss">

$assets: '~@/assets/images/game/part-1/';

#game .part-1 {

  .game__title {
    position: absolute;
    top: vw(239);
    left: 0;
    width: 100%;
    p {
      font-size: vw(36);
      text-align: center;
      letter-spacing: vw(letterSpacing(500, 36));
      line-height: lineHeight(36, 60);
      @include narrow-text;
      @include neon-text;
    }
  }

  .game__icon {
    position: absolute;
    top: vw(452);
    left: vw(291);
    width: vw(169);
    height: vw(146);
    background: url($assets + 'icon-camera.png') no-repeat 0 0 / contain;
  }

  .game__note {
    position: absolute;
    top: vw(630);
    left: 0;
    width: 100%;
    p {
      font-size: vw(36);
      text-align: center;
      letter-spacing: vw(letterSpacing(350, 36));
      line-height: 1;
      @include narrow-text;
      @include neon-text;
    }
  }

  // .game__agreement {
  //   position: absolute;
  //   top: vw(1118);
  //   left: vw(140);
  //   padding-left: vw(38);
  //   input {
  //     position: absolute;
  //     top: 0;
  //     left: 0;
  //     width: 0;
  //     height: 0;
  //     opacity: 0;
  //     cursor: pointer;
  //   }
  //   span {
  //     position: absolute;
  //     top: vw(2);
  //     left: 0;
  //     width: vw(24);
  //     height: vw(24);
  //     border: #fff vw(2) solid;
  //     background: #591f21;
  //     &::after {
  //       display: none;
  //       content: '';
  //       position: absolute;
  //       top: vw(3);
  //       left: vw(3);
  //       width: vw(13);
  //       height: vw(13);
  //       background: url($assets + 'icon-check.png') no-repeat center center / vw(13) vw(13);
  //       pointer-events: none;
  //     }
  //   }
  //   input:checked ~ span::after {
  //     display: block;
  //   }
  //   p {
  //     width: vw(460);
  //     font-size: vw(18);
  //     font-weight: 500;
  //     letter-spacing: vw(letterSpacing(200, 18));
  //     line-height: lineHeight(18, 24);
  //     &:nth-of-type(2) {
  //       letter-spacing: vw(letterSpacing(130, 18));
  //     }
  //   }
  // }

}

</style>
